/**
 * Module dependencies.
 */

import { Market } from 'src/types/markets';
import {
  QueryObserverBaseResult,
  QueryObserverOptions,
  useQuery
} from 'react-query';
import { fetchMarket } from './fetch-market';
import { useMemo } from 'react';
import { useRouter } from 'next/router';

/**
 * `Result` type.
 */

type Result = QueryObserverBaseResult<Market, unknown>;

/**
 * `Options` type.
 */

type Options = QueryObserverOptions<Market> & {
  slug: string;
};

/**
 * Action type.
 */

const actionType = ({ locale, slug }): string => {
  return `${locale}-markets-${slug}`;
};

/**
 * `useMarket` hook.
 */

function useMarket(options?: Options): Result {
  const { slug, ...rest } = options ?? {};
  const { locale } = useRouter();
  const variables = useMemo(
    () => ({
      locale,
      slug
    }),
    [locale, slug]
  );

  const result = useQuery(
    [actionType(variables), variables],
    () => {
      return fetchMarket(variables);
    },
    rest
  );

  return result;
}

/**
 * Export `useMarket` hook.
 */

export default useMarket;
